export default "__VITE_ASSET__e34d4b40__"